import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import PageContact from "containers/PageContact/PageContact";
import PageLogin from "containers/PageLogin/PageLogin";
import ListingRealEstatePage from "containers/ListingRealEstatePage/ListingRealEstatePage";
import SiteHeader from "containers/SiteHeader";
import useWindowSize from "hooks/useWindowResize";
import ListingExperiencesDetailPage from "containers/ListingDetailPage/listing-experiences-detail/ListingExperiencesDetailPage";
import MamTeMocHome from './../containers/PageHome/MamTeMocHome';
import PagePrivacy from "containers/PrivacyPage/Privacy";
import PageRegulations from "containers/PrivacyPage/Regulations";
import OverviewHome from "containers/PageHome/OverviewHome";
import RegHome from "containers/PageHome/RegHome";
import JoinTheMeeting from "containers/JoinTheMeeting/JoinTheMeeting";
import CheckOutVoucherPage from "containers/CheckOutPage/CheckOutVoucherPage";
import CheckOutCartPage from "containers/CheckOutPage/CheckOutCartPage";
import StefanHome from "containers/PageHome/StefanHome";

export const pages: Page[] = [
  { path: "/", exact: true, component: MamTeMocHome },
  { path: "/#", exact: true, component: MamTeMocHome },

  {
    path: "/event/:id",
    component: ListingExperiencesDetailPage,
  },

  { path: "/catalog", component: ListingRealEstatePage },
  { path: "/privacy", component: PagePrivacy },
  { path: "/regulations", component: PageRegulations },
  { path: "/overview", component: OverviewHome },
  { path: "/meeting/:uid", component: JoinTheMeeting },
  { path: "/reg", component: RegHome },
  { path: "/stefan", component: StefanHome },


  { path: "/checkout/:id", component: CheckOutPage },
  { path: "/checkout", component: CheckOutCartPage },
  { path: "/checkout-voucher/:id", component: CheckOutVoucherPage },
  { path: "/pay-done/", component: PayPage },

  { path: "/contact", component: PageContact },

  { path: "/login", component: PageLogin },


];

const MyRoutes = () => {
  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route element={<Page404 />} />
      </Routes>

      {/* {WIN_WIDTH < 768 && <FooterNav />} */}
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
